// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__kXlYa {
    background-color: #040404;
    color: white;
    padding: 5rem 0 2rem;
    font-family: 'Urbanist', sans-serif;
  }
  
  .Footer_container__R7sXj {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }
  
  /* Footer Top Section */
  .Footer_footerTop__AqnA2 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 3rem;
  }
  
  /* Brand Section */
  .Footer_footerBrand__cLTt0 {
    flex: 0 0 100%;
    max-width: 350px;
    margin-bottom: 2rem;
  }
  
  .Footer_logoContainer__QVj8n {
    margin-bottom: 1.5rem;
  }
  
  .Footer_logo__\\+JiYo {
    height: 24px;
    width: auto;
  }
  
  .Footer_tagline__a4seh {
    font-size: 1rem;
    line-height: 1.5;
    margin-bottom: 2rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  /* Social Links Section */
  .Footer_socialLinksContainer__oGNnq {
    margin-top: 2rem;
  }
  
  .Footer_socialTitle__GMloN {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .Footer_socialLinks__8J74g {
    display: flex;
    gap: 8px;
  }
  
  .Footer_socialLink__p-nyn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-right: 0.8rem;
    transition: all 0.3s ease;
  }
  
  .Footer_socialLink__p-nyn:hover {
    transform: translateY(-3px);
  }
  
  /* Links Section */
  .Footer_footerLinks__3aiFY {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex: 1 1;
    margin-left: 4rem;
  }
  
  .Footer_linksColumn__tLpDh {
    flex: 0 0 auto;
    margin-right: 2rem;
    margin-bottom: 2rem;
  }
  
  .Footer_columnTitle__0rNjT {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    position: relative;
  }
  
  
  .Footer_linksList__u3jNX {
    list-style: none;
    padding: 0;
  }
  
  .Footer_linksList__u3jNX li {
    margin-bottom: 0.8rem;
  }
  
  .Footer_linksList__u3jNX a {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    font-size: 0.95rem;
    transition: color 0.3s ease;
  }
  
  .Footer_linksList__u3jNX a:hover {
    color: #00f5d4;
  }
  
  /* Footer Divider */
  .Footer_footerDivider__f3\\+fT {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.1);
    margin: 2rem 0;
  }
  
  /* Footer Bottom */
  .Footer_footerBottom__XPvsq {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  
  .Footer_copyright__JQMtz {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.6);
  }
  
  .Footer_legalLinks__HIHkX {
    display: flex;
  }
  
  .Footer_legalLinks__HIHkX a {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    font-size: 0.9rem;
    margin-left: 1.5rem;
    transition: color 0.3s ease;
  }
  
  .Footer_legalLinks__HIHkX a:hover {
    color: white;
  }
  
  /* Responsive Design */
  @media (max-width: 992px) {
    .Footer_footerLinks__3aiFY {
      margin-left: 0;
    }
  }
  
  @media (max-width: 768px) {
    .Footer_footerTop__AqnA2 {
      flex-direction: column;
    }
    
    .Footer_footerBrand__cLTt0 {
      max-width: 100%;
    }
    
    .Footer_footerLinks__3aiFY {
      width: 100%;
    }
    
    .Footer_linksColumn__tLpDh {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(50% - 2rem);
    }
    
    .Footer_footerBottom__XPvsq {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    
    .Footer_copyright__JQMtz {
      margin-bottom: 1rem;
    }
    
    .Footer_legalLinks__HIHkX {
      margin-bottom: 1rem;
    }
    
    .Footer_legalLinks__HIHkX a {
      margin: 0 0.75rem;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAO;IACP,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;EACpB;;;EAGA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,0CAA0C;IAC1C,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA,sBAAsB;EACtB;IACE;MACE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,YAA0B;MAA1B,cAA0B;MAA1B,4BAA0B;IAC5B;;IAEA;MACE,sBAAsB;MACtB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":[".footer {\n    background-color: #040404;\n    color: white;\n    padding: 5rem 0 2rem;\n    font-family: 'Urbanist', sans-serif;\n  }\n  \n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 2rem;\n  }\n  \n  /* Footer Top Section */\n  .footerTop {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-bottom: 3rem;\n  }\n  \n  /* Brand Section */\n  .footerBrand {\n    flex: 0 0 100%;\n    max-width: 350px;\n    margin-bottom: 2rem;\n  }\n  \n  .logoContainer {\n    margin-bottom: 1.5rem;\n  }\n  \n  .logo {\n    height: 24px;\n    width: auto;\n  }\n  \n  .tagline {\n    font-size: 1rem;\n    line-height: 1.5;\n    margin-bottom: 2rem;\n    color: rgba(255, 255, 255, 0.8);\n  }\n  \n  /* Social Links Section */\n  .socialLinksContainer {\n    margin-top: 2rem;\n  }\n  \n  .socialTitle {\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n  }\n  \n  .socialLinks {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .socialLink {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    margin-right: 0.8rem;\n    transition: all 0.3s ease;\n  }\n  \n  .socialLink:hover {\n    transform: translateY(-3px);\n  }\n  \n  /* Links Section */\n  .footerLinks {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    flex: 1;\n    margin-left: 4rem;\n  }\n  \n  .linksColumn {\n    flex: 0 0 auto;\n    margin-right: 2rem;\n    margin-bottom: 2rem;\n  }\n  \n  .columnTitle {\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n    position: relative;\n  }\n  \n  \n  .linksList {\n    list-style: none;\n    padding: 0;\n  }\n  \n  .linksList li {\n    margin-bottom: 0.8rem;\n  }\n  \n  .linksList a {\n    color: rgba(255, 255, 255, 0.7);\n    text-decoration: none;\n    font-size: 0.95rem;\n    transition: color 0.3s ease;\n  }\n  \n  .linksList a:hover {\n    color: #00f5d4;\n  }\n  \n  /* Footer Divider */\n  .footerDivider {\n    height: 1px;\n    background-color: rgba(255, 255, 255, 0.1);\n    margin: 2rem 0;\n  }\n  \n  /* Footer Bottom */\n  .footerBottom {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .copyright {\n    font-size: 0.9rem;\n    color: rgba(255, 255, 255, 0.6);\n  }\n  \n  .legalLinks {\n    display: flex;\n  }\n  \n  .legalLinks a {\n    color: rgba(255, 255, 255, 0.6);\n    text-decoration: none;\n    font-size: 0.9rem;\n    margin-left: 1.5rem;\n    transition: color 0.3s ease;\n  }\n  \n  .legalLinks a:hover {\n    color: white;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 992px) {\n    .footerLinks {\n      margin-left: 0;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .footerTop {\n      flex-direction: column;\n    }\n    \n    .footerBrand {\n      max-width: 100%;\n    }\n    \n    .footerLinks {\n      width: 100%;\n    }\n    \n    .linksColumn {\n      flex: 0 0 calc(50% - 2rem);\n    }\n    \n    .footerBottom {\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n    }\n    \n    .copyright {\n      margin-bottom: 1rem;\n    }\n    \n    .legalLinks {\n      margin-bottom: 1rem;\n    }\n    \n    .legalLinks a {\n      margin: 0 0.75rem;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__kXlYa`,
	"container": `Footer_container__R7sXj`,
	"footerTop": `Footer_footerTop__AqnA2`,
	"footerBrand": `Footer_footerBrand__cLTt0`,
	"logoContainer": `Footer_logoContainer__QVj8n`,
	"logo": `Footer_logo__+JiYo`,
	"tagline": `Footer_tagline__a4seh`,
	"socialLinksContainer": `Footer_socialLinksContainer__oGNnq`,
	"socialTitle": `Footer_socialTitle__GMloN`,
	"socialLinks": `Footer_socialLinks__8J74g`,
	"socialLink": `Footer_socialLink__p-nyn`,
	"footerLinks": `Footer_footerLinks__3aiFY`,
	"linksColumn": `Footer_linksColumn__tLpDh`,
	"columnTitle": `Footer_columnTitle__0rNjT`,
	"linksList": `Footer_linksList__u3jNX`,
	"footerDivider": `Footer_footerDivider__f3+fT`,
	"footerBottom": `Footer_footerBottom__XPvsq`,
	"copyright": `Footer_copyright__JQMtz`,
	"legalLinks": `Footer_legalLinks__HIHkX`
};
export default ___CSS_LOADER_EXPORT___;
